const body = document.body;
const idEnquete = document.currentScript.getAttribute('data-id-enquete');
const permiteMultiplasOpcoes =
  document.currentScript.getAttribute('data-multiplas-opcoes') === 'true';
const permiteMultiplosVotos =
  document.currentScript.getAttribute('data-multiplos-votos') === 'true';
const voteConfirmedModal = document.getElementById('voteConfirmed');
const modalResults = document.getElementById('surveyResults');
const alertModal = document.getElementById('alertModal');
const surveyOptions = document.querySelectorAll(
  '.survey-option input[type=radio], .survey-option input[type=checkbox]',
);
const surveyVoteButton = document.querySelector('.survey-control .btn--vote');
const surveyOptionImage = document.querySelectorAll(
  '.survey-options .survey-option > .survey-option__image',
);
const parcialResults = document.querySelectorAll(
  '#surveyResults .survey-options--results .survey-option',
);

// Função genérica para mostrar um modal
function showModal(modalElement) {
  body.style.overflow = 'hidden';
  modalElement.style.display = 'block';
}

// Função genérica para fechar um modal
function closeModal(modalElement) {
  body.style.overflow = 'auto';
  modalElement.style.display = 'none';
}

// Mostrar resultado parcial
function showPartialResult() {
  dataLayerCliqueEnquete('Ver Resultado', 'botao:resultado');
  closeVoteConfirmedModal();
  closeModalAlert();
  showModal(modalResults);
}

// Fechar modal de resultado parcial
function closePartialResultsModal() {
  closeModal(modalResults);
}

function updateSurveyResultsUI(results) {
  const totalVotosSpan = document.querySelector('#surveyResults h3 span');

  if (totalVotosSpan) totalVotosSpan.textContent = results.totalVotos;

  const opcoes = results.opcoes;
  const opcoesIds = opcoes.map(opcao => opcao.id);

  // Percorre todas as opções no HTML
  parcialResults.forEach(option => {
    const idOpcaoResposta = option.getAttribute('data-id-resposta');

    // Verifica se a opção possui correspondência no JSON
    const opcaoIndex = opcoesIds.indexOf(idOpcaoResposta);
    const votosSpan = option.querySelector('span');

    if (opcaoIndex !== -1) {
      // Opção encontrada no JSON, atribui o valor de votos correspondente
      votosSpan.textContent = opcoes[opcaoIndex].votos;
    } else {
      // Opção não encontrada no JSON, define o valor como "0%"
      votosSpan.textContent = '0%';
    }
  });
}

function updateSurveyResults() {
  return new Promise((resolve, reject) => {
    fetch(`${idEnquete}/resultado`)
      .then(response => {
        if (!response.ok) {
          throw new Error('Erro na resposta da requisição GET');
        }
        return response.json();
      })
      .then(data => {
        const results = {
          totalVotos: data.total,
          opcoes: data.opcoes,
        };
        resolve(results);
      })
      .catch(error => {
        console.error('Ocorreu um erro ao obter os resultados da enquete:', error);
        reject(error);
      });
  });
}

// Chamada da função para obter os resultados da enquete e atualizar o HTML
function loadSurveyResults() {
  updateSurveyResults()
    .then(results => {
      updateSurveyResultsUI(results);
    })
    .catch(error => {
      console.error('Ocorreu um erro:', error);
    });
}

loadSurveyResults();

// Função para ler o valor do cookie
function getCookieValue(name) {
  const cookies = document.cookie.split(';');
  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i].trim();
    if (cookie.startsWith(name + '=')) {
      return decodeURIComponent(cookie.substring(name.length + 1));
    }
  }
  return null;
}

window.addEventListener('load', () => {
  const hasCookie = getCookieValue('enqueteOpcaoSelecionada');
  const isLoggedUser = getCookieValue('lumIsLoggedUser');

  if (isLoggedUser === 'true' && hasCookie) {
    confirmVote(hasCookie);
  }
});

// Confirmar voto
function confirmVote(cookieValue) {
  dataLayerCliqueEnquete('Votar', 'botao:votar');
  surveyVoteButton.classList.add('btn--loading', 'button--loading');

  const selectedInputs = document.querySelectorAll('.survey-option input:checked');

  const arraySelectedOptions = cookieValue
    ? JSON.parse(cookieValue).opcaoResposta
    : Array.from(selectedInputs).map(input => input.id);

  const selectedOptions = document.querySelectorAll('.survey-option input:checked');

  const url = '/enquete/votar';
  const data = {
    enquete: idEnquete,
    opcaoResposta: arraySelectedOptions,
  };

  fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  })
    .then(response => {
      if (!response.ok) {
        return response.json().then(data => {
          if (data.message === 'A enquete já está encerrada')
            showModalAlert(data.message, 'Ver resultados');
          else showModalAlert(data.message, 'Ver resultado parcial');
          throw new Error(data.message);
        });
      } else {
        const location = response.headers.get('location');

        if (location) {
          window.location.href = location;
          return Promise.reject(new Error('Redirecionando para página de login...'));
        }

        return response.json();
      }
    })
    .then(() => {
      showModal(voteConfirmedModal);
      surveyVoteButton.classList.remove('btn--loading', 'button--loading');
      surveyVoteButton.disabled = true;
      selectedOptions.forEach(option => {
        option.parentElement.classList.remove('choosen-option');
        option.checked = false;
      });

      // Atualizar os resultados da enquete
      loadSurveyResults();

      document.cookie = 'enqueteOpcaoSelecionada=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
    })
    .catch(error => {
      console.error('Ocorreu um erro ao efetuar o voto na enquete:', error);

      surveyVoteButton.classList.remove('btn--loading', 'button--loading');
    });
}

// Fechar modal de confirmação de voto
function closeVoteConfirmedModal() {
  closeModal(voteConfirmedModal);
}

// Mostrar alerta de pesquisa já votada
function showModalAlert(message, btnText) {
  const alertMessageElement = document.querySelector('.alert-message');
  const alertMessageButton = document.querySelector('#alertModal .btn--show-partial-result');
  alertMessageElement.textContent = message;
  alertMessageButton.textContent = btnText;
  showModal(alertModal);
}

// Fechar modal de pesquisa já votada
function closeModalAlert() {
  closeModal(alertModal);
}

function handleSurveyOptionClick() {
  const selectedOptions = document.querySelectorAll('.survey-option input:checked');
  const unselectedOptions = document.querySelectorAll('.survey-option input:not(:checked)');

  unselectedOptions.forEach(option => {
    option.parentElement.classList.remove('choosen-option');
  });

  selectedOptions.forEach(option => {
    option.parentElement.classList.add('choosen-option');
  });

  surveyVoteButton.disabled = selectedOptions.length === 0;
}

function handleSurveyOptionImageClick(event) {
  const optionImage = event.currentTarget;
  const optionName = optionImage.getAttribute('optionName');

  if (!optionImage.classList.contains('enlarged-image')) {
    dataLayerCliqueEnquete(optionName, 'expandir:imagem:opcao');
    body.style.overflow = 'hidden';
    optionImage.classList.add('enlarged-image');
  } else {
    body.style.overflow = 'auto';
    optionImage.classList.remove('enlarged-image');
  }
}

surveyOptions.forEach(option => {
  option.addEventListener('click', handleSurveyOptionClick);
});

surveyOptionImage.forEach(optionImage => {
  optionImage.addEventListener('click', handleSurveyOptionImageClick);
});
